<template>
  <div
    class="ren-decoration-cp ren-decoration-cp-image"
    :class="{ 'is-empty': !imageUrl }"
    :style="frameStyle">
    <img
      v-if="imageUrl"
      :src="imageUrl"
      :alt="altText"
      :style="{ objectFit: fitMode }" />
    <span v-else>图片</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { widgetMediaUrl } from '../../media'
import type { WidgetPreviewProps } from '../../types'
import { widgetHasFixedHeight } from '../../widget-style'
import { WIDGET_STYLE_FALLBACKS } from '../../widget-style-defaults'

const props = defineProps<WidgetPreviewProps>()

const imageUrl = computed(() => widgetMediaUrl(props.component.props?.imageUrl))
const altText = computed(() => {
  const value = props.component.props?.altText ?? props.component.props?.alt
  if (value) return String(value)
  return props.component.title || '图片'
})
const fitMode = computed(() => {
  const value = String(props.component.props?.fitMode ?? 'COVER').toUpperCase()
  if (value === 'CONTAIN') return 'contain'
  if (value === 'FILL') return 'fill'
  return 'cover'
})
const frameStyle = computed(() =>
  widgetHasFixedHeight(props.component.style)
    ? undefined
    : { minHeight: `${WIDGET_STYLE_FALLBACKS.mediaHeight}px` },
)
</script>
